import { asImageSrc, asLink } from "@prismicio/helpers";
import { typedBoolean } from "../helper";
export const transSocial = (socials) => [...(socials || [])]
    .map((i) => i.items.map((item) => ({ href: asLink(item.url) || "", image: asImageSrc(item.social_image) || "" })))
    .flat()
    .filter(typedBoolean)
    .filter((i) => i.image && i.href);
